(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["logo-list"] && !Shopify.designMode) return;
  try {
    
  class LogoSlider {
    constructor(container) {
      this.container = container;
      this.slider = this.container.querySelector('.logo-bar__slider');
      this.slides = Array.from(this.slider.children);
      this.slidesToShow = parseInt(this.container.dataset.slidesToShow) || 6;
      this.autoplay = this.container.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(this.container.dataset.autoplaySpeed) * 1000 || 5000;
      this.currentIndex = 0;
      this.totalSlides = this.slides.length;
      this.autoplayInterval = null;
      this.prevButton = this.container.querySelector('.logo-bar__arrow--prev');
      this.nextButton = this.container.querySelector('.logo-bar__arrow--next');
  
      this.init();
    }
  
    init() {
      this.setupSlider();
      if (this.autoplay) {
        this.startAutoplay();
      }
      this.prevButton.addEventListener('click', () => this.scroll(-1));
      this.nextButton.addEventListener('click', () => this.scroll(1));
      window.addEventListener('resize', () => this.handleResize());
    }
  
    setupSlider() {
      const slideWidth = 100 / this.slidesToShow;
  
      this.slider.style.width = `${(this.totalSlides + this.slidesToShow) * slideWidth}%`;
      this.slides.forEach((slide) => {
        slide.style.width = `${slideWidth}%`;
      });
  
      // Clone the first few slides and append to the end for infinite scrolling
      const clones = this.slides.slice(0, this.slidesToShow).map(slide => slide.cloneNode(true));
      clones.forEach(clone => this.slider.appendChild(clone));
  
      this.updateSliderPosition();
    }
  
    startAutoplay() {
      this.autoplayInterval = setInterval(() => this.scroll(1), this.autoplaySpeed);
    }
  
    stopAutoplay() {
      clearInterval(this.autoplayInterval);
    }
  
    scroll(direction) {
      if (this.autoplay) {
        this.stopAutoplay();
      }
  
      this.currentIndex += direction;
  
      if (this.currentIndex >= this.totalSlides) {
        this.slider.style.transition = 'none';
        this.currentIndex = 0;
        this.updateSliderPosition();
        setTimeout(() => {
          this.slider.style.transition = 'transform 0.5s ease';
          this.currentIndex++;
          this.updateSliderPosition();
        }, 10);
      } else if (this.currentIndex < 0) {
        this.slider.style.transition = 'none';
        this.currentIndex = this.totalSlides - 1;
        this.updateSliderPosition();
        setTimeout(() => {
          this.slider.style.transition = 'transform 0.5s ease';
          this.currentIndex--;
          this.updateSliderPosition();
        }, 10);
      } else {
        this.updateSliderPosition();
      }
  
      if (this.autoplay) {
        this.startAutoplay();
      }
    }
  
    updateSliderPosition() {
      const offset = -this.currentIndex * (100 / (this.totalSlides + this.slidesToShow));
      this.slider.style.transform = `translateX(${offset}%)`;
    }
  
    handleResize() {
      this.setupSlider();
      this.updateSliderPosition();
    }
  }
  
  document.addEventListener('DOMContentLoaded', () => {
    const logoSliders = document.querySelectorAll('.logo-bar');
    logoSliders.forEach((slider) => new LogoSlider(slider));
  });


  } catch(e) { console.error(e); }
})();
})();
